import React from 'react';
import { createClassName } from '../../utils/createClassName';

import './finishScreenLayoutStyles.scss';

type TopAlign = 'center' | 'end';

type Props = {
  top: React.ReactNode;
  middle: React.ReactNode;
  bottom?: React.ReactNode;
  topAlign?: TopAlign;
};

export const FinishScreenLayout: React.FC<Props> = (props) => {
  const { top, middle, bottom, topAlign = 'center' } = props;
  const className = createClassName('finishScreenLayout');

  return (
    <div className={className()}>
      <div className={className('top')}>
        <div className={className(`align-${topAlign}`)}>{top}</div>
      </div>
      <div className={className('middle')}>{middle}</div>
      {bottom && <div className={className('bottom')}>{bottom}</div>}
    </div>
  );
};
